/**
 * Business logic for mapping items to icons (cacheable SVG icons).
 */

import type { IconName, IconVariant } from '../../../../../components/icons/iconPaths';

export interface ItemIconResult {
  name: IconName;
  variant: IconVariant;
}

/**
 * Maps an item string to an appropriate icon (name + variant) based on keywords.
 * Used for displaying icons next to benefits, skills, etc.
 */
export function getIconForItem(item: string): ItemIconResult {
  const b = item.toLowerCase();
  const defaultIcon: ItemIconResult = { name: 'briefcase', variant: 'outline' };

  if (['lunch', 'meal', 'food', 'dining', 'ruoka', 'lounas', 'måltid', 'mat', 'måltider'].some((kw) => b.includes(kw)))
    return { name: 'briefcase', variant: 'outline' };
  if (['health', 'insurance', 'medical', 'wellness', 'terveys', 'sairaus', 'vakuutus', 'sairausvakuutus', 'terveydenhuolto', 'hälsa', 'sjukförsäkring', 'sjukvård'].some((kw) => b.includes(kw)))
    return { name: 'wifi', variant: 'outline' };
  if (['phone', 'mobile', 'device', 'puhelin', 'mobiili', 'laite', 'telefon', 'mobil', 'enhet'].some((kw) => b.includes(kw)))
    return { name: 'mapPin', variant: 'outline' };
  if (['transport', 'commute', 'travel', 'matka', 'liikenne', 'kuljetus', 'pendelöinti', 'resor', 'resa'].some((kw) => b.includes(kw)))
    return { name: 'arrowUpOnSquare', variant: 'outline' };
  if (['sports', 'gym', 'fitness', 'exercise', 'urheilu', 'kuntosali', 'liikunta', 'sport', 'träning'].some((kw) => b.includes(kw)))
    return { name: 'bookmark', variant: 'outline' };
  if (['education', 'training', 'course', 'learning', 'koulutus', 'opiskelu', 'kurssi', 'utbildning', 'kurs', 'lärande'].some((kw) => b.includes(kw)))
    return { name: 'bookmark', variant: 'solid' };
  if (['bonus', 'reward', 'extra', 'bonukset', 'palkkio', 'lisä', 'belöning'].some((kw) => b.includes(kw)))
    return { name: 'briefcase', variant: 'outline' };
  if (['vacation', 'holiday', 'leave', 'lomapäivä', 'loma', 'vapaa', 'semester', 'ledighet', 'lov'].some((kw) => b.includes(kw)))
    return { name: 'mapPin', variant: 'outline' };
  if (['interview', 'meeting', 'haastattelu', 'tapaaminen', 'intervju', 'möte'].some((kw) => b.includes(kw)))
    return { name: 'arrowUpOnSquare', variant: 'outline' };
  if (['test', 'assessment', 'evaluation', 'koe', 'arviointi', 'testi', 'bedömning', 'prov'].some((kw) => b.includes(kw)))
    return { name: 'wifi', variant: 'outline' };
  if (['skill', 'competence', 'ability', 'taito', 'osaaminen', 'kompetenssi', 'färdighet', 'kompetens'].some((kw) => b.includes(kw)))
    return { name: 'briefcase', variant: 'outline' };

  return defaultIcon;
}
